module.exports = __webpack_public_path__ + "fa9755b65373c6cee3b350e987333a6c.svg";